<template>
    <div class="slider-image" :class="[this.active == true ? 'active' : 'inactive']">
        <img :src='"https://marmor-kunze.de/static/images/slider/"+ this.image'>
        <router-link v-if="this.title" :to='this.link != null ? this.link : "#"' class="slider-text">
            <h1 v-if="this.title">{{ this.title | uppercase}}</h1>
            <h4 v-if="this.subtitle">{{ this.subtitle}}</h4>
        </router-link>
       <!--  <router-link v-else to="#" class="slider-text invisible">
            <h1 v-if="this.title">{{ this.title | uppercase}}</h1>
            <h4 v-if="this.subtitle">{{ this.subtitle}}</h4>
        </router-link> -->
    </div>
</template>

<script>

export default {
  name: 'slideritem',
  props:['active','image','title','subtitle','link'],
  data () {
    return {
    }
  },
  created(){
  },
  filters: {
      uppercase: function (value) {
	    return value.toUpperCase()
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* .slideritem{
    padding:50px;
    padding-left:10%;
    padding-top:45vh;
    transition: all 1.5s ease;
    background-size: cover;
}
.slideritem.active{
    opacity:1;
}
.slideritem.inactive{
    opacity:0;
}
.slider-text{
    position: relative;
    color:white;
    text-align:left;
     text-shadow: 0 0 20px #333
}
.slideritem.inactive h2{
    padding-top:0px;
}
.slideritem.inactive h3{
    padding-top:15vh;
}
.slideritem.active h2{
    padding-top:7.5vh;
}
.slideritem.active h3{
    padding-top:0;
}
h2{
    transition: all .4s ease;
    font-size:4em;
}
h3{
    transition: all .4s ease;
    font-size:2em;
}
 */
</style>



// WEBPACK FOOTER //
// src/components/interface/Slider/SliderItem.vue